import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtSelectEnhancementsCtrl(
  $timeout,
  $filter,
  $scope,
  $window,
  SubjectStore,
  ValidationService,
  ShoppingCartStore
) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.personalizationIsValid = false;
  this.formTouched = false;
  this.allSubjects = [];
  this.allSubjects = SubjectStore.getSortedVerifiedAndJobSubjects();
  if (this.allSubjects.length > 0) {
    this.selectedSubject = SubjectStore.getSelectedSubject();
  }
  this.hasOptOut = $scope.hasOptOut;
  this.isBasicRetouching = $scope.isBasicRetouching;
  this.standardizedPricingOptIns = $scope.standardizedPricingOptIns;
  this.personalizationName = $scope.personalizationName;
  this.partialEnhancements = !$scope.partialEnhancements;
  this.noNoGo = $scope.noNoGo;
  this.packageHasNoYo = $scope.packageHasNoYo;
  this.noRetouching = $scope.noRetouching;
  this.personalizationIsValid = $scope.personalizationIsValid;
  this.isStandardizedPricingPackage = $scope.isStandardizedPricingPackage;
  this.availableEnhancements = $scope.availableEnhancements;
  this.sku = $scope.sku;
  this.upgradeOptions = $scope.upgradeOptions;

  this.init = function () {
    if ($window.innerWidth < 767 && document.getElementById('enhancement-retouching')) {
      document.getElementById('enhancement-retouching').scrollIntoView();
    }

    var unwatchStandardizedPricingOptIns = $scope.$watch(
        'standardizedPricingOptIns',
        function (standardizedPricingOptIns) {
          this.standardizedPricingOptIns = standardizedPricingOptIns;
        }.bind(this)
      ),
      unwatchPersonalizationName = $scope.$watch(
        'personalizationName',
        function (personalizationName) {
          this.personalizationName = personalizationName;
        }.bind(this)
      ),
      unwatchHasOptOut = $scope.$watch(
        'hasOptOut',
        function (hasOptOut) {
          this.hasOptOut = hasOptOut;
        }.bind(this)
      ),
      unwatchIsBasicRetouching = $scope.$watch(
        'isBasicRetouching',
        function (isBasicRetouching) {
          this.isBasicRetouching = isBasicRetouching;
        }.bind(this)
      ),
      unwatchPersonalizationIsValid = $scope.$watch(
        'personalizationIsValid',
        function (personalizationIsValid) {
          this.personalizationIsValid = personalizationIsValid;
        }.bind(this)
      );

    $scope.$on('$destroy', function () {
      unwatchStandardizedPricingOptIns();
      unwatchPersonalizationName();
      unwatchHasOptOut();
      unwatchIsBasicRetouching();
      unwatchPersonalizationIsValid();
    });

    $scope.$on('setDefaultSelectionsToEnhancements', function () {
      $scope.updateStdPriceRetouchingOptIn({ optIn: true });
      $scope.updateStdPricePersonalizationOptIn({ optIn: true });
    });
  };

  this.updateStdPriceRetouchingOptIn = function (optIn) {
    $scope.updateStdPriceRetouchingOptIn({ optIn: optIn });
  };

  this.updatePersonalizationName = function () {
    $scope.updatePersonalizationName({ personalizationName: this.personalizationName });
  };

  this.updateStdPricePersonalizationOptIn = function (optIn) {
    $scope.updateStdPricePersonalizationOptIn({ optIn: optIn });
  };

  this.saveToCart = function () {
    $scope.saveToCart();
  };

  this.isPersonalizationNameInvalid = function () {
    return !$filter('SpecialCharacterValidationFilter')(this.personalizationName);
  };

  this.goToPreviousPage = function () {
    $scope.goToPreviousPage();
  };

  this.goToTop = function () {
    $window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  this.enhancementNumberForBox = function (enhancementType) {
    var type = {
      RETOUCHING: 1,
      PERSONALIZATION: 2
    };
    return type[enhancementType];
  };

  this.validatePersonalizationName = function () {
    var flag = true;
    if ((!this.partialEnhancements && this.noRetouching) || this.noNoGo) {
      return flag;
    }

    if (this.standardizedPricingOptIns.personalization) {
      if (
        $scope.standardizedPricingPersonalizationForm.personalizationName.$dirty ||
        $scope.standardizedPricingPersonalizationForm.personalizationName.$viewValue
      ) {
        var valid = ValidationService.validateInputLength(
          $scope.standardizedPricingPersonalizationForm.personalizationName,
          1,
          20
        );
        if (!this.personalizationIsValid || !valid) {
          flag = false;
        }
      } else {
        flag = false;
      }
    }

    return flag;
  };

  this.subjectContainsStandardizedPricingBundles = function () {
    return ShoppingCartStore.subjectContainsStandardizedPricingBundles();
  };

  this.getPlaceholder = function (contentKey) {
    return $filter('ltTranslateFilter')(contentKey);
  };
}

App.controller('LtSelectEnhancementsCtrl', [
  '$timeout',
  '$filter',
  '$scope',
  '$window',
  'SubjectStore',
  'ValidationService',
  'ShoppingCartStore',
  LtSelectEnhancementsCtrl
]);
